import React from 'react';

const FileInputIcon: React.FC = () => (
    <svg  width="22" height="22" viewBox="0 0 22 22"
    fill="none">
    <path
        d="M14.2507 5.99996L7.20899 12.5C6.77801 12.8978 6.53589 13.4374 6.53589 14C6.53589 14.5626 6.77801 15.1021 7.20899 15.5C7.63997 15.8978 8.2245 16.1213 8.83399 16.1213C9.44348 16.1213 10.028 15.8978 10.459 15.5L17.5007 8.99996C18.3626 8.20432 18.8469 7.12518 18.8469 5.99996C18.8469 4.87475 18.3626 3.79561 17.5007 2.99996C16.6387 2.20432 15.4696 1.75732 14.2507 1.75732C13.0317 1.75732 11.8626 2.20432 11.0007 2.99996L3.95899 9.49996C2.66606 10.6934 1.9397 12.3121 1.9397 14C1.9397 15.6878 2.66606 17.3065 3.95899 18.5C5.25192 19.6934 7.00551 20.3639 8.83399 20.3639C10.6625 20.3639 12.4161 19.6934 13.709 18.5L20.7507 12"
        stroke="#666666" strokeWidth={"2"} strokeLinecap={"round"} strokeLinejoin={"round"} />
</svg>
);

export default FileInputIcon;
